<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box ">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.region)">
                                        <!-- :disabled="isGeographicalAreaDisable" -->
                                        <label>Geographical Area</label>
                                        <select v-model="tripRoute.region" @change="selectGA" required name="region"
                                            class="form-control">
                                            <option value="" disabled>Select G.A</option>
                                            <option v-for="(item, index) in region_list" :key="index" :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select>
                                        <field-messages name="region" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.startSite)">
                                        <label>Start Location</label>
                                        <select v-model="tripRoute.startSite" required name="startSite" class="form-control"
                                            @change="addLatLng">
                                            <option value="" disabled>Select Start Location</option>
                                            <option v-for="(item, index) in start_site" :key="index" v-bind:value="item._id"
                                                v-bind:lat="item.latitude" v-bind:long="item.longitude"
                                                v-bind:startmessageMarker="item.siteName">
                                                {{ item.siteName }}
                                            </option>
                                        </select>
                                        <field-messages name="startSite" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Start Location is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.endSite)">
                                        <label>End Location</label>
                                        <select v-model="tripRoute.endSite" required name="endSite" class="form-control"
                                            @change="addEndLatLng">
                                            <option value="" disabled>Select End Location</option>
                                            <option v-for="(item, index) in end_site" :key="index" v-bind:value="item._id"
                                                v-bind:endLat="item.latitude" v-bind:endLong="item.longitude"
                                                v-bind:endmessageMarker="item.siteName">
                                                {{ item.siteName }}
                                            </option>
                                        </select>
                                        <field-messages name="endSite" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">End Location is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>

                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.approxDistance)">
                                        <label>Approx. Distance(km) </label>
                                        <input type="number" name="approxDistance" class="form-control" required
                                            v-model.lazy="tripRoute.approxDistance" min="0" placeholder="Approx. Distance">
                                        <field-messages name="approxDistance" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Approx. Distance is a required field</div>
                                            <!-- <div slot="pattern">Capacity is invalid</div>
                                            <div slot="min">Minimum 100 kg Capacity</div>
                                            <div slot="max">Maximum 30000 kg Capacity</div> -->
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.approxTime)">
                                        <label>Approx. Time (in Min)</label>
                                        <input type="number" min="0" max="2880" name="approxTime" class="form-control"
                                            required v-model.lazy="tripRoute.approxTime" placeholder="Approx. Time">
                                        <field-messages name="approxTime" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Approx. Time is a required field</div>
                                            <div slot="max">Maximum Time for a Trip is 2 days</div>
                                            <!-- <div slot="pattern">Registration no is invalid</div>
                                            <div slot="minlength">Minimum length of registration no is 10 character</div> -->
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select required v-model="tripRoute.status" name="status" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status date is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group"
                                        :class="fieldClassName(formstate.reportAssessment)">
                                        <label>Route Risk Assessment Report</label>
                                        <input type="file" id="file" class="form-control" ref="reportAssesssment"
                                            @change="onFilechanged" />
                                        <field-messages name="reportAssessment" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Route' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-4 btn gradientbt" type="submit" @click="createRoute"
                                :disabled="!(formstate.$dirty && formstate.$valid)">Add Route</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template> 

<script>
import { formService, eventBus, tripRouteService } from '../../../services'
import { EVENTS } from '../../../config'
import axios from 'axios'
import { mapState } from 'vuex';
export default {
    name: 'RouteCreate',
    data() {
        return {
            loading: false,
            isGeographicalAreaDisable: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list: {},
            region_managers: {},
            start_site: {},
            end_site: {},
            r_id: {},
            paramValue: [],
            params: {},
            journeyManager: [],
            a: [],
            tripRoute: {
                region: '',
                startSite: '',
                endSite: '',
                reportAssessment: '',
                status: 'active',
                routeMarkers: [{
                    latitude: '',
                    longitude: '',
                    message: '',
                },
                {
                    latitude: '',
                    longitude: '',
                    message: '',
                }],

            },
            routeMarkers: [{
                latitude: '',
                longitude: '',
                message: '',
            }],
            photo: {},
            regionManagersIdList: [],

        }

    },
    mounted: function () {
        this.getRegionList()
        this.getSalesManager()
        // this.getSiteName()

    },
    created() {
        let regionDetails = this.$store.state.auth.userRegion.regionDetails;
        if (regionDetails && regionDetails.length !== 0) {
            this.regionManagersIdList = regionDetails.map(item => item.regionManager);
        }
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        selectGA() {
            this.getSiteName(this.tripRoute.region);
        },


        addLatLng(event) {

            this.lat = event.target.options[event.target.selectedIndex].getAttribute('lat');
            this.long = event.target.options[event.target.selectedIndex].getAttribute('long');
            console.log(event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker'))
            this.tripRoute.routeMarkers.splice(0, 1, { latitude: this.lat, longitude: this.long, message: event.target.options[event.target.selectedIndex].getAttribute('startmessageMarker') })
            console.log("this.tripRoute.routeMarkers", this.tripRoute.routeMarkers)
        },
        addEndLatLng(event) {
            this.endLat = event.target.options[event.target.selectedIndex].getAttribute('endLat');
            this.endLong = event.target.options[event.target.selectedIndex].getAttribute('endLong');
            this.endmessageMarker = event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker');
            this.tripRoute.routeMarkers.splice(this.tripRoute.routeMarkers.length - 1, 1, { latitude: this.endLat, longitude: this.endLong, message: event.target.options[event.target.selectedIndex].getAttribute('endmessageMarker') })
        },
        onFilechanged(event) {
            this.photo = event.target.files[0];
            this.tripRoute.reportAssessment = event.target.files[0]['name']
        },

        add(index) {
            let markerLength = this.tripRoute.routeMarkers.length
            this.tripRoute.routeMarkers.splice(markerLength - 1, 0, {})

            console.log('added')
        },

        remove(index) {
            console.log('remove function called')
            if (this.tripRoute.routeMarkers.length > 1) {
                this.tripRoute.routeMarkers.splice(index, 1);
                console.log('removed')
            }
        },
        getSiteName(id) {
            const params = {}
            params.$limit = 0;
            let siteList = [];
            // if (this.user.roleName === "Journey Manager") {
            //     params.regionJourneyManager = `["${this.user._id}"]`;
            // }
            params.region = id;
            this.$siteDataRepository.list(params)
                .then((res) => {
                    this.loading = false;

                    if (res.data.docs) {
                        siteList = res.data.docs;
                    }
                    this.start_site = siteList;
                    this.end_site = siteList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error('site.requestFunction-error:', error)
                    this.$snotify.error('Get site list failed', 'Error!')
                })

        },
        getRegionList() {
            this.loading = true;
            this.params.$limit = 0;
            if (this.user.roleName == "GA Head") {
                this.params.regionManager = this.regionManagersIdList;
            }
            if (this.user.roleName === "Journey Manager") {
                this.isGeographicalAreaDisable = true;
                this.params = {
                    ...this.params,
                    journeyManager: this.a.splice(0, 1, [this.user._id]),
                }
                this.params.journeyManager = `["${this.user._id}"]`;
            }
            let regionlist = [];
            this.$regionDataRepository.list(this.params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.docs) {
                        regionlist = res.data.docs.map((item) => {
                            return {
                                key: item._id,
                                value: item.name
                            }
                        })
                    }
                    this.region_list = regionlist;
                    if (this.region_list.length === 1) {
                        this.region_list ? (this.tripRoute.region = this.region_list[0].key) : (this.tripRoute.region = '');
                        this.selectGA();
                    }
                    // this.user.roleName === "Journey Manager" ? this.tripRoute.region = this.region_list[0].key : this.tripRoute.region = '';
                })
                .catch((error) => {
                    this.loading = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },

        createRoute() {
            this.loading = true;
            this.tripRoute = {
                ...this.tripRoute,
                //routeMarkers : JSON.stringify(this.tripRoute.routeMarkers),
                //reportAssessment : JSON.stringify(this.tripRoute.reportAssessment),
            }
            console.log("hii there", this.tripRoute)
            return tripRouteService.addtripRoute(this.tripRoute)
                .then((response) => {
                    let docId = response._id;
                    this.uploadDocument(docId)
                    this.loading = false
                    this.flash = false
                    this.$snotify.success('route added!', 'Success!')
                    this.$router.push('/routes')
                })
                .catch(error => {
                    this.loading = false
                    this.$snotify.error('trip Add failed! Try Again', 'Error!')
                    if (error.data.message.includes('must be one of')) {
                        this.flash = true
                        this.flashType = 'error'
                        this.flashMessage = 'New route add is failed.Please try again!'
                    }
                })
        },
        uploadDocument(docId) {
            let formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model', "driver");
            formData.append("docId", docId)
            axios.post('fileUpload',
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            ).then(res => {
                console.log(res)
                console.log('SUCCESS!!');
            })
                .catch(function () {
                    console.log('FAILURE!!');
                });
        },
        getSalesManager() {
            this.loading = true;
            const params = {}
            params.$limit = 0;
            params.roleRank = 4;
            let regionManagerList = [];
            this.$userRepository.list(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.docs) {
                        regionManagerList = res.data.docs.map((item) => {
                            return {
                                key: item._id,
                                value: item.firstName + ' ' + item.lastName
                            }
                        })

                    }
                    this.region_managers = regionManagerList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error('Region Manager.requestFunction-error:', error)
                    this.$snotify.error('Get region manager list failed', 'Error!')
                })
        },
        validateLatitude(e) {
            let reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");
            if (reg.exec(e.target.value)) {
                this.tripRoute = {
                    ...this.tripRoute,
                    latitude: e.target.value
                }
            } else {
                e.preventDefault();
            }
        },
        validateLongitude(e) {
            let reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");
            if (reg.exec(e.target.value)) {
                this.tripRoute = {
                    ...this.tripRoute,
                    longitude: e.target.value
                }
            } else {

            }
        },
        fieldClassName: function (field) {
            if (!field) {
                return '';
            }
            if ((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if ((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }

    },
    computed: {
        ...mapState({
            user: state => state.auth.user,

        }),
    }
}


</script>  
<style scoped>
.required-field>label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red
}

.mt {
    margin-top: 7px;
}

.fa {
    font-size: 35px;
    margin: 5px;
    margin-bottom: 5px;
}

.marker {
    margin-bottom: 20px;

}

.gradientbt {
    background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
    color: white
}

.addbutton {
    background-color: rgba(255, 132, 78);
    color: white
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
</style>                                          




// WEBPACK FOOTER //
// RouteCreate.vue?c3fd0b56